import React from "react";
import Banner from "./Banner";
import "./Services.css";
import Brands from "./Brands";
const Services = () => {
  return (
    <div>
      <div>
        <Banner title="services" imgURL="/images/servicesbanner.png" />
      </div>
      <div className="our-best-services">
        <h2>Our Best Services</h2>
        <p>
          We have good terms and relations in this field and according to
          requirement, we work and try to make our deals better always.
        </p>
        <div className="primary-locations">
          <h3>Primary Locations</h3>
          <ul>
            <li>DELHI</li>
            <li>UTTAR PRADESH</li>
            <li>RAJASTHAN</li>
            <li>HARYANA</li>
          </ul>
        </div>
        <div className="associates">
          <h3>We serve on PAN INDIA basis.</h3>
          {/* <ul>
            <li>PUNJAB</li>
            <li>MUMBAI</li>
            <li>INDORE</li>
          </ul> */}
        </div>
      </div>
      <div>
        <Brands />
      </div>
    </div>
  );
};

export default Services;
